import { Link } from "react-router-dom";
export default function PaymentCancel() {
  return (
    <div data-testid="payment-cancel-page" className="max-w-2xl mx-auto px-6 sm:px-10 py-24 text-center">
      <h1 className="h-editorial text-5xl">Cancelled.</h1>
      <p className="mt-4 text-zinc-400">No charge was made. The slot is still yours to reserve.</p>
      <div className="mt-10 flex gap-3 justify-center">
        <Link to="/dashboard/book" className="rc-btn-primary">Try Again</Link>
        <Link to="/dashboard" className="rc-btn-ghost">Portal</Link>
      </div>
    </div>
  );
}
